import { render, staticRenderFns } from "./open-time.vue?vue&type=template&id=4dc48d88&scoped=true&"
import script from "./open-time.vue?vue&type=script&lang=ts&"
export * from "./open-time.vue?vue&type=script&lang=ts&"
import style0 from "./open-time.vue?vue&type=style&index=0&id=4dc48d88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc48d88",
  null
  
)

export default component.exports